
import Vue from 'vue';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(
    'section',
    { staticClass: 'a404page' },
    [
      _c('secondary-nav'),
      _c(
        'div',
        { staticClass: 'su-body' },
        [
          _c('div', { staticClass: 'su-section-seven container su-section-contact' }, [
            _c('div', { staticClass: 'row' }, [
              _c('div', { staticClass: 'col-1 void-column' }),
              _c('div', { staticClass: 'col-12 col-md-11' }, [
                _c('div', { staticClass: 'row expetation-title' }, [
                  _c('div', { staticClass: 'col-12' }, [
                    _c('p', [_vm._v('Become our')]),
                    _c('h1', [_vm._v('Speciality Artists (Acrobat, Aerial & Circus Skills)')]),
                    _c('p', [
                      _vm._v(
                        ' We are currently looking for extraordinary Speciality Artists — including Acrobats, Aerial Artists, and Circus Skills performers — to join our team at Showup Productions. If you have exceptional skills and are ready to dazzle audiences in world-class live productions, we want to hear from you. ',
                      ),
                    ]),
                  ]),
                ]),
                _c('div', { staticClass: 'row expetation-body' }, [
                  _c('div', { staticClass: 'col-12' }, [
                    _c('div', { staticClass: 'row mt-4' }, [
                      _c('div', { staticClass: 'col-auto mr-3' }, [
                        _c(
                          'a',
                          {
                            staticClass: 'su-button',
                            attrs: {
                              href: 'https://forms.monday.com/forms/e8193f116d0d94286c240c198cd322b7?r=euc1',
                              target: '_blank',
                            },
                          },
                          [_vm._v('Apply as Solo')],
                        ),
                      ]),
                      _c('div', { staticClass: 'col-auto' }, [
                        _c(
                          'a',
                          {
                            staticClass: 'su-button',
                            attrs: {
                              href: 'https://forms.monday.com/forms/77ef67fb33b8129130402715dce39eec?r=euc1',
                              target: '_blank',
                            },
                          },
                          [_vm._v('Apply as Group')],
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c('footer-row'),
          _c('alert-row', { ref: 'alertMsg' }),
        ],
        1,
      ),
    ],
    1,
  );
};
var staticRenderFns = [];

export default Vue.extend({ render, staticRenderFns });
